import {
  Box,
  Flex,
  Button,
  Text,
  FormControl,
  FormLabel,
  Textarea,
} from '@chakra-ui/react'

import useTracking from 'tracking/useTracking'
import { useAppParams } from 'routes/utils'
import useSubmitQuestionMutation from 'api/useSubmitQuestion'
import { FormErrorMessage, LoadingSuccess } from 'components'
import { Field, Form, Formik } from 'formik'

const RequestsPage = () => {
  const apiStatus = useSubmitQuestionMutation()
  const { app, pageSlug, subPageSlug } = useAppParams()
  const [tracking] = useTracking()

  const handleSubmit = (values: { question: string }) => {
    apiStatus.mutate({
      app,
      message: `-----DISEASE REQUEST------ \n\n ${values.question}`,
      url: window.location.href,
      page: pageSlug,
      subpage: subPageSlug,
    })
    tracking.sendAnalystQuestion({})
  }

  const validateQuestion = (value: string) => {
    let error
    if (!value) {
      error = 'Question is required'
    } else if (apiStatus.isError) {
      error = apiStatus.error?.message
    }
    return error
  }

  if (apiStatus.isLoading) {
    return <LoadingSuccess isLoading={apiStatus.isLoading} />
  }

  if (apiStatus.isError) {
    return (
      <Flex
        flexDirection='column'
        justifyContent='space-between'
        alignItems='center'
        textAlign='center'
      >
        <Text
          mx='auto'
          mt={12}
          as='p'
          color='error'
          fontWeight='normal'
          fontSize='md'
          px={4}
        >
          Something went wrong while trying to submit your question
        </Text>
        <Button
          variant='yellow'
          mx='auto'
          mt={12}
          onClick={() => apiStatus.reset()}
        >
          Try again
        </Button>
      </Flex>
    )
  }

  if (apiStatus.isLoading || apiStatus.isSuccess) {
    return (
      <>
        <LoadingSuccess isLoading={apiStatus.isLoading} />
        <Flex
          flexDirection='column'
          justifyContent='space-between'
          alignItems='center'
        >
          <Text mt={6} as='p' fontWeight='normal' fontSize='md'>
            An analyst will review your request.
          </Text>
        </Flex>
      </>
    )
  }

  return (
    <Box bg='gray.50' h='full' pt={'2rem'}>
      <Box w='fit-content'>
        <Formik
          initialValues={{ question: '' }}
          onSubmit={(values, actions) => {
            handleSubmit(values)
            actions.setSubmitting(false)
            apiStatus.isSuccess && actions.resetForm()
          }}
          validateOnChange={false}
          validateOnBlur={false}
        >
          {(_props) => (
            <Form>
              <Field name='question' validate={validateQuestion}>
                {({ field, form }: any) => (
                  <FormControl
                    px='1.5rem'
                    isInvalid={form.errors.question && form.touched.question}
                    id='question'
                  >
                    <FormLabel
                      fontSize='large'
                      htmlFor='question'
                      color='black'
                      my={5}
                    >
                      Which disease would you like to request?
                    </FormLabel>
                    <Textarea
                      {...field}
                      width={'500px'}
                      autoFocus
                      id='question'
                      fontSize='medium'
                      placeholder='Type the disease here…'
                      minH='5rem'
                      resize='none'
                      borderRadius='sm'
                      border='1px solid'
                      borderColor='gray2'
                      bg='white'
                    />
                    {form.errors.question && (
                      <FormErrorMessage>
                        {form.errors.question}
                      </FormErrorMessage>
                    )}
                  </FormControl>
                )}
              </Field>
              <Box px='1.5rem' w='full'>
                <Button
                  variant='yellow'
                  mt={3}
                  w='100%'
                  float='right'
                  isLoading={apiStatus.isLoading}
                  type='submit'
                  tabIndex={0}
                >
                  Send Request
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  )
}

export default RequestsPage
